import DashboardLayout from 'components/DashboardLayout';
import FormPA from 'components/FormPA';
import FormPaStateProvider from 'components/FormPA/formPaProvider';
import React, { FC } from 'react';
import { RouteComponentProps } from 'react-router';
import { PractitionerViewPaViewModel } from './PractitionerViewPa.ViewModel';

const PractitionerViewPa: FC<RouteComponentProps> = () => {
  const vm = PractitionerViewPaViewModel();

  if (vm.loading) return <div>Loading ...</div>;
  if (!vm.formData) return <div>Form details not set ...</div>;

  return (
    <div>
      <FormPaStateProvider formDetails={vm.formData} viewPage>
        <DashboardLayout>
          <FormPA />
        </DashboardLayout>
      </FormPaStateProvider>
    </div>
  );
};

export default PractitionerViewPa;
